export const getStrategyStatusLabel = (active: boolean | null | undefined): string => {
  if (active == null) {
    return '—'
  }

  return active ? 'ACTIVE' : 'INACTIVE'
}
